import { render, staticRenderFns } from "./chiplist.vue?vue&type=template&id=d78d40be&scoped=true&lang=pug&"
var script = {}
import style0 from "./chiplist.vue?vue&type=style&index=0&id=d78d40be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78d40be",
  null
  
)

export default component.exports